/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_Col_Avg_AtsInputs */

const en_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg ATS`)
};

const de_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchschn. ATS`)
};

const fr_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS moyen`)
};

const es_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS promedio`)
};

const it_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS medio`)
};

const nl_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem. ATS`)
};

const pl_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śr. ATS`)
};

const fi_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskim. ATS`)
};

const da_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gns. ATS`)
};

const sv_analytics_resume_perf_col_avg_ats = /** @type {(inputs: Analytics_Resume_Perf_Col_Avg_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gns. ATS`)
};

/**
* | output |
* | --- |
* | "Avg ATS" |
*
* @param {Analytics_Resume_Perf_Col_Avg_AtsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_col_avg_ats = /** @type {((inputs?: Analytics_Resume_Perf_Col_Avg_AtsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_Col_Avg_AtsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "es") return es_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "it") return it_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "da") return da_analytics_resume_perf_col_avg_ats(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_col_avg_ats(inputs)
	return en_analytics_resume_perf_col_avg_ats(inputs)
});